import type { IconData } from '@stacksjs/iconify-core'

export const mediaRecord: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M256 72C154.542 72 72 154.542 72 256s82.542 184 184 184s184-82.542 184-184S357.458 72 256 72m0 336c-83.813 0-152-68.187-152-152s68.187-152 152-152s152 68.187 152 152s-68.187 152-152 152\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mediaRecord
